const acAuth = {
	AUTH_USER_TOKEN: "AUTH_USER_TOKEN",
	AUTH_USER_DATA: "AUTH_USER_DATA",
};

export default acAuth;
